import React from "react"
import { Grid, Button } from "semantic-ui-react"
import { Redirect } from "react-router-dom"
import { ConfirmModal, Prompt } from "uikit"
//TODO: Duplicate of Account/WorksheetTypes/Footer footer.
export const Footer = ({
  baseUrl,
  isNew,
  onDelete,
  submitLabel,
  onSubmit,
  onCancel,
  isPending,
  isModified,
  deleteLabel,
  entityName,
  verification,
  deleteText,
  showDeleteButton,
  error
}) => (
  <>
    {!!error ? (
      <Grid.Row style={{ background: "red", color: "white" }}>
        <Grid.Column textAlign="center">{error}</Grid.Column>
      </Grid.Row>
    ) : null}
    <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
      <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
        {isNew ? (
          <Button
            basic
            content="Cancel"
            type="button"
            color="blue"
            onClick={() => onCancel()}
          />
        ) : showDeleteButton ? (
          <ConfirmModal
            buttonLabel={deleteLabel}
            onConfirm={onDelete}
            success={<Redirect to={`${baseUrl}`} />}
            header="Are You Sure?"
            verification={verification}
            description={
              deleteText ? (
                deleteText
              ) : (
                <span>
                  If you proceed, you will permanently remove this {entityName}.
                  <strong> You cannot undo this action.</strong>
                </span>
              )
            }
          />
        ) : null}
      </Grid.Column>
      <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
        <Button
          data-testid="done"
          content={submitLabel}
          onClick={onSubmit}
          primary
          type="button"
          disabled={isPending}
          loading={isPending}
        />
        <Prompt when={isModified} />
      </Grid.Column>
    </Grid.Row>
  </>
)

Footer.defaultProps = {
  deleteLabel: "Delete",
  submitLabel: "Yes",
  showDeleteButton: true
}
